import {
  CREATE_PAYMENT_NEW_RECORD,
  CREATE_PAYMENT_NEW_RECORD_SUCCESS,
  CREATE_PAYMENT_NEW_RECORD_ERROR, 

  GET_PAYMENTMETHOD_RECORDS,
  GET_PAYMENTMETHOD_RECORDS_SUCCESS,
  GET_PAYMENTMETHOD_RECORDS_ERROR,

  SET_RECORD_TYPE,
  UPDATE_NEW_RECORD_STATE,
} from "../actions";
import EnumRecordTypes from "../../enums/enumRecordTypes";

const INIT_STATE = {
  loading: false,
  error: "",
  record: {},
  paymentItemRecord: {},
  paymentId: null,
  recordList: {
    records: [],
    pagination: {
      pageNumber: 1,
      pageSize: 5,
      startIndex: 1,
      totalItemCount: 0,
      totalPages: 0,
    },
    selectedRecords: {},
    responseTime: null
  },
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
     case GET_PAYMENTMETHOD_RECORDS:
      return {
        ...state,
        loading: true,
        error: "",
        recordList: null,
        selectedRecordType:
          typeof action.payload.recordType === "string"
            ? getRecordType(action.payload.recordType)
            : action.payload.recordType,
        displayStatus: action.payload.displayStatus,
        pageNumber: action.payload.pageNumber,
        parentRecordId: action.payload.parentRecordId,
        selectedFilters: action.payload.selectedFilters,
        vocabularyId: action.payload.vocabularyId,
        profile: action.payload.profile,
        params: action.payload.params,
        hasUserAccount: action.payload.hasUserAccount ? action.payload.hasUserAccount : ""
      };
    case GET_PAYMENTMETHOD_RECORDS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
        recordList: action.payload,
      };
    case GET_PAYMENTMETHOD_RECORDS_ERROR:
      const recordList = { ...state.recordList, records: [] };
      recordList.pagination = {
        ...recordList.pagination,
        totalItemCount: 0,
        totalPages: 0,
      };
      return {
        ...state,
        loading: false,
        error: action.payload.message,
        recordList,
      };

    case CREATE_PAYMENT_NEW_RECORD:
      return { ...state, loading: true, error: "", record: action.payload.newRecord, selectedFilters: action.payload.selectedFilters };
    case CREATE_PAYMENT_NEW_RECORD_SUCCESS:
      return { ...state, loading: false, error: "", record: action.payload, isNewRecordPanelShown: false };
    case CREATE_PAYMENT_NEW_RECORD_ERROR:
      return { ...state, loading: false, error: action.payload.message };

    case SET_RECORD_TYPE:
      return { ...state, recordTypeSelected: action.payload.recordTypeSelected };
    case UPDATE_NEW_RECORD_STATE:
      return { ...state, ...action.payload.updatedValues }
    default:
      return { ...state };
  }
};

const getRecordType = (recordTypeString) => {
  let recordTypeValue = EnumRecordTypes.Person;
  for (const key in EnumRecordTypes) {
    if (key.toLowerCase() === recordTypeString.toLowerCase()) {
      recordTypeValue = EnumRecordTypes[key];
      break;
    }
  }
  return recordTypeValue;
};